import React from 'react';

import './Upload.scss';

import addImageIcon from './add-image.png';

const getFileType = (type: string) => {
  switch (type) {
    case 'png':
    case 'jpeg':
      return `image/${type}`;
    case 'jpg':
      return `image/jpeg`;
    case 'doc':
      return 'application/msword';
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    case 'pdf':
      return 'application/pdf';
    case 'xls':
    case 'xlsx':
      return 'application/vnd.ms-excel';
    default:
      return type;
  }
};

interface CustomProps {
  name: string;
  id: string;
  onFileChosen?: (file?: File) => void;
  disabled?: boolean;
  title?: string;
  description?: string;
  accept?: string[];
  hideLabel?: boolean;
  sm?: boolean;
}

const FileUpload: React.SFC<CustomProps> = (props: CustomProps) => {
  const handleChange = (selectedFiles: FileList) => {
    let file: File | undefined;
    if (selectedFiles && selectedFiles.length > 0) {
      file = selectedFiles[0];
    }
    if (props.onFileChosen) {
      props.onFileChosen(file);
    }
  };
  return (
    <>
      {!props.hideLabel && <label className="fieldlabel">{props.title}</label>}
      <label
        className={`border btn btn-default uploading-group-inn rounded-0 btn-block d-flex align-items-center ${
          props.sm === true ? 'py-2 px-3' : 'bg-gray-100 justify-content-center'
        }`}
      >
        <div
          className={`${
            props.sm === true ? 'd-flex align-items-center' : 'd-block'
          }`}
        >
          {props.sm === true ? (
            <i className="icon-upload mr-2 pr-1 font-xxl"></i>
          ) : (
            <img src={addImageIcon} className="py-2" />
          )}
          <p
            className={`m-0 text-gray-900 ${
              props.sm === true ? 'font-sm font-weight-semibold' : 'font-normal'
            }`}
          >
            Upload {props.title}
          </p>
          <input
            type="file"
            id={props.id}
            onChange={(e: any) => handleChange(e.target.files)}
            disabled={props.disabled}
            hidden
            accept={
              props.accept
                ? props.accept.map((t) => getFileType(t)).join(', ')
                : undefined
            }
          />
        </div>
      </label>
    </>
  );
};

export default FileUpload;
